import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { AuthService } from '~auth/services/auth.service';
import { Authenticator } from '~auth/providers';
import { IdleService } from './idle.service';
import { User, UserProfile, UserStatus } from '~auth/model';

const defaultUserStatus = {
  status: false,
  showModal: false
};

@Injectable()
export class UserService implements Authenticator {
  user: BehaviorSubject<User> = new BehaviorSubject<User>(null);
  userStatusSubject: BehaviorSubject<UserStatus> = new BehaviorSubject<UserStatus>(defaultUserStatus);

  private idleTimer: Subscription;
  private pingTimer: Subscription;

  constructor(private auth: AuthService, private idle: IdleService) {
    if (auth.isAuthenticated()) {
      this.auth.refresh(true)
        .take(1)
        .do(() => this.startTimers())
        .subscribe(user => this.user.next(user));
    }
  }

  getUser(): Observable<UserProfile> {
    return this.user
      .asObservable();
  }

  getUserStatus() {
    return this.userStatusSubject
      .asObservable();
  }

  updateUserStatus(json: UserStatus) {
    this.userStatusSubject.next(json);
  }

  signIn(username: string, password: string): Observable<User> {
    this.resetTimers();

    return this.auth.signIn(username, password)
      .do(() => this.startTimers())
      .switchMap(user => {
        this.user.next(user);
        return this.user;
      });

  }

  signOut(): Observable<boolean> {
    this.resetTimers();

    return this.auth.signOut()
      .do(() => this.user.next(null));
  }

  private startTimers() {
    this.resetTimers();
    this.idleTimer = this.idle.onIdle(this.idle.minutes(30))
      .switchMap(() => this.signOut())
      .take(1)
      .subscribe();

    this.pingTimer = this.auth.ping()
      .flatMap(success => {
        if (!success) return this.signOut();
      })
      .subscribe();
  }

  private resetTimers() {
    if (this.idleTimer) this.idleTimer.unsubscribe();
    if (this.pingTimer) this.pingTimer.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/user.service.ts